import styled from "styled-components";
import theme from "../../../../styles/theme";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-color: ${theme.colors.brown.capivara};
`;

export const LoginBox = styled.div`
  width: 100%;
  max-width: 400px;
  padding: 2rem;
  background-color: ${theme.colors.brown.capivaraLightAux};
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;

  @media (max-width: 600px) {
    padding: 1.5rem;
  }
`;

export const Logo = styled.div`
  display: flex;
  justify-content: center;
  img {
    max-width: 250px;
    height: auto;
  }
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 2vh;
`;
